import classnames from "classnames";
import "./Checkbox.sass";

const Checkbox = ({ children, className, checked, onChange }) => {
  return (
    <label className={classnames("auth-form__checkbox-label", className)}>
      <div className="auth-form__checkbox-input-wrapper">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="auth-form__checkbox-input"
        />
        <div
          className={classnames(
            "auth-form__checkbox-box",
            checked && "auth-form__checkbox-box--checked",
          )}
        >
          {checked && (
            <svg
              width="9"
              height="9"
              viewBox="0 0 9 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.5 4.7L3.32353 7.5L8.5 0.5"
                stroke="#FF6C22"
                strokeLinecap="round"
              />
            </svg>
          )}
        </div>
      </div>
      <span className="auth-form__checkbox-text">{children}</span>
    </label>
  );
};

export default Checkbox;
